import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  @Input() subService = "  I'm a Web Developer and Graphic Designer ,Angular Expert with 3+ years of working experience. If you need a skilled and communicative developer and designer, please feel free to contact me anytime !!";
  @Input() backEnd= {name:'Back-End', p:'I have experience of working with software like (Node.js, Express, APIs, SQL, MySQL, Microsoft SQL Server, MongoDB,  Firebase Realtime Database )' };
  @Input() frontEnd = {name:'Front-End' , p:' I also have experience of working with software like (HTML5, CSS3, JavaScript, Bootstrap, Angular Material, Angular 8)'} ;
  @Input() photography = {name:'Photography' , p:'I will take high-quality photos for you for your website, e-commerce or print.I have a quick turn around and can help capture a variety of products.'};
  @Input() responsiveDesign = {name:'Responsive Design' , p:'I am a professional web developer and expert designer with a decade of successful i will provide Fully Responsive Website as per your requirements.'};
  @Input() GraphicDisign = {name:'Graphic Design' , p:'Check out my ratings and work samples and you ll see that my designs work! I always work very closely with my clients, turnaround time is very fast and my communication excellent.'};
  @Input() bIAnalyst = {name:'BI Analyst' , p:'I am a Software Engineer with masters in Business Intelligence.I have also worked on several mobile and web apps. Now I run my own IT company called FlashStore.'};


  constructor() { }

  ngOnInit() {
  }

}
